import { motion } from 'framer-motion';

interface ProjectCardProps {
  title: string;
  description: string;
  tags: string[];
  color: string;
  index: number;
}

export default function ProjectCard({ title, description, tags, color, index }: ProjectCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.4 }}
      className="rounded-xl border p-5 mb-4 backdrop-blur-md
                 transition-all duration-300 hover:scale-[1.02]"
      style={{
        background: `linear-gradient(135deg, ${color}08, ${color}03)`,
        borderColor: `${color}25`,
      }}
    >
      <div className="flex items-start gap-3 mb-3">
        <div
          className="w-2 h-2 rounded-full mt-2 flex-shrink-0"
          style={{ background: color, boxShadow: `0 0 8px ${color}` }}
        />
        <h3 className="text-white font-semibold text-base leading-tight">{title}</h3>
      </div>

      <p className="text-gray-400 text-sm leading-relaxed mb-4 pl-5">
        {description}
      </p>

      <div className="flex flex-wrap gap-2 pl-5">
        {tags.map((tag) => (
          <span
            key={tag}
            className="px-2.5 py-1 rounded-md text-xs font-mono"
            style={{
              background: `${color}12`,
              color: `${color}cc`,
              border: `1px solid ${color}20`,
            }}
          >
            {tag}
          </span>
        ))}
      </div>
    </motion.div>
  );
}
